<template>
  <div id="app">
  	<!-- <Header></Header> -->
    <router-view></router-view>
    <!-- <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
      @close="randomLogin"
      >
      <span>Network Error!Please try again!</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">OK</el-button>
      </span>
    </el-dialog> -->
    <!-- <Footer v-if="!$route.meta.removeFooter"></Footer> -->
  </div>
</template>
<!-- <script src="./plugins/firebase.js"></script> -->

<script>

export default {
    name: "App",
    mounted(){
      // console.log(this,11111111)
      // this.$loading().close()
    }
}
</script>

<style>

</style> 
